module.exports = __webpack_public_path__ + "static/img/frame 5.3c4ce111.png";